module.exports = __webpack_public_path__ + "img/pool.ca2a5fd5.png";